import {
  TGetProjectsRepsonse,
  TUpdateAgencyPayload,
  TUserAgencyInvitationPayload,
  TUserProjectInvitationPayload
} from './types'
import axios, { AxiosResponse } from 'axios'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const createAgencyThunk = createAsyncThunk(
  'agency/createAgencyThunk',
  async (data: FormData, { rejectWithValue }) => {
    try {
      const response: AxiosResponse<TGetProjectsRepsonse> = await axios.post(`/agencies`, data)
      return response.data
    } catch (err) {
      return rejectWithValue((err as any).response.data)
    }
  }
)

export const getAgencyThunk = createAsyncThunk(
  'agency/getAgencyThunk',
  async (agencyId: any, { rejectWithValue }) => {
    try {
      const response: AxiosResponse<any> = await axios.get(`agencies/${agencyId}`)
      return response.data
    } catch (err) {
      console.log(err)
      return rejectWithValue((err as any).response.data)
    }
  }
)

export const updateAgencyThunk = createAsyncThunk(
  'agency/updateAgencyThunk',
  async ({ agencyId, data }: TUpdateAgencyPayload, { rejectWithValue }) => {
    try {
      const response: AxiosResponse<any> = await axios.post(`agencies/${agencyId}`, data)
      return response.data
    } catch (err) {
      console.log(err)
      return rejectWithValue((err as any).response.data)
    }
  }
)

export const inviteToAgencyThunk = createAsyncThunk(
  'agency/inviteToAgencyThunk',
  async (data: TUserAgencyInvitationPayload, { rejectWithValue }) => {
    try {
      const response: AxiosResponse<any> = await axios.post(`/userinvitations/agency/send`, data)
      return response
    } catch (err) {
      console.log(err)
      return rejectWithValue((err as any).response.data)
    }
  }
)

export const inviteToProjectThunk = createAsyncThunk(
  'agency/inviteToProjectThunk',
  async (data: TUserProjectInvitationPayload, { rejectWithValue }) => {
    try {
      const response: AxiosResponse<any> = await axios.post(`/userinvitations/project/send`, data)
      return response.data
    } catch (err) {
      console.log(err)
      return rejectWithValue((err as any).response.data)
    }
  }
)

export const getAgencyInvitationsThunk = createAsyncThunk(
  'agency/getAgencyInvitations',
  async (agencyId: any, { rejectWithValue }) => {
    try {
      const response: AxiosResponse<any> = await axios.get(`agencies/${agencyId}/invitations`)
      return response.data
    } catch (err) {
      console.log(err)
      return rejectWithValue((err as any).response.data)
    }
  }
)
